import React, { useState,forwardRef,useImperativeHandle, useEffect,useRef } from 'react';
import { Avatar, Badge, Breadcrumb, Button, Card, Checkbox, Col, Divider, Drawer, Flex, Form, Input, Layout, List, message, Popconfirm, Row, Select, Steps, Table, Tabs, Tag, Typography } from 'antd';
import { AppstoreOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import CreateTeam from './CreateTeam';
import CurrentTeams from './CurrentTeams';
import RequestApproval from '../../../restAPI/RequestApproval';
import { useSelector } from 'react-redux';

const { Option } = Select;
const { Text } = Typography;

const Members = forwardRef(({setData,savedData},ref) =>{
    const { companyId, token, userCompany, role } = useSelector(state => state.auth);
    const [open, setOpen] = useState(false);
    const [count, setcount] = useState(0);
    const [showInput, setShowInput] = useState(false);
    const [selectedTeams,setSelectedTeams] = useState(savedData.selectedTeam);
    const [openItem, setOpenItem] = useState(1);
    const [showNameField, setShowNameField] = useState(savedData.isNewTeam);
    const [hocUsers,setHocUsers] = useState(savedData.hocUsers)
    const [formData,setFormData] = useState({
        circulerType:"",
        selectedTeams:[],
        selectedMembers:[],
        isNewTeam:false
    })

    const defaultTeam = {
        name: "",
        companyId : companyId,
        circulationType: "",
        members: []
    }
    const [form] = Form.useForm();
     
    const [dataSource, setDataSource] = useState([]);
    const [companyTeams, setCompanyTeams] = useState([]);

    const [teams,setTeams] = useState([]);
    const [nextKey, setNextKey] = useState(4);
    const [team,setTeam] = useState(savedData.team);

    const  createTeamRef = useRef(null);
    const  currentTeamRef = useRef(null);
    
    
    useEffect(()=>{
        getAllTeams();
        // console.log(savedData.team,"zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz")
    },[])

    RequestApproval.testWithJWTandCID(companyId,token);

    useImperativeHandle(ref, () => ({
        async saveMembersdata(){
            // console.log(templateViewState,"")
            //setData(fileList);
            try{
                let backupTeam = await currentTeamRef.current.SelectTeamBackup();
                let result ={
                    team : backupTeam.createdTeam,
                    isNewTeam : showNameField,
                    selectedTeam:backupTeam.selectedTeams,
                    hocUsers:backupTeam.hocUsers
    
                }
    
                setData(result);
    
                return result
            }catch(err){
                console.error('Validation Failed:', err);
            }
            
            // console.log(result,"send backup data");
        },
        async validateWorkflow(){
            let backupTeam = await currentTeamRef.current.validateWorkflow();
            // console.log(backupTeam,"backuppdpdpdpdppdp wwwwwwwwwwwwwwwwwwwwwwwwwwww")
            if(backupTeam.status){
                let result ={
                    team : backupTeam.obj.createdTeam,
                    isNewTeam : showNameField,
                    selectedTeam:backupTeam.obj.selectedTeams
    
                }
    
                // setData(result);

                return {status:true,resultObj:result};
            }else{
                return {status:false,resultObj:null};
            }
        }
    }));

    const getAllTeams =() => {
        // console.log("Tem");setCompanyTeams
        const data = RequestApproval.getTeamsForCompany().then((data) => {
            let teams = []

            data.data.forEach((element,index) => {
                let obj = {
                    id: element._id,
                    name: element.name,
                    type: element.circulationType
                }
                teams.push(obj);
            });

            setCompanyTeams(data.data);
            setTeams(teams);
            // console.log(data,"Teams of company api data");
            // console.log(teams,"Teams of company converted data");
        });
    }

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const handleCheckboxChange = (e) => {
        // console.log(e.target.checked,"e.target.checked xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
        // setShowInput(e.target.checked);
        setShowNameField(e.target.checked)
    };

    const handleAddUser = () => {
        const newRow = {
            key: nextKey.toString(),
            actionOptions: ['Approve', 'View'],
            name: null, // Name is null initially, will be selected via dropdown
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        };
        setDataSource([...dataSource, newRow]); // Add new row to data source
        setNextKey(nextKey + 1); // Increment key for the next row
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'actionOptions',
            key: 'action',
            render: (actionOptions) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select defaultValue={actionOptions[0]} showSearch>
                        {actionOptions.map((action, idx) => (
                            <Select.Option key={idx} value={action}>
                                {action}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name, record, index) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select
                    showSearch
                        variant="borderless"
                        defaultValue={name || 'Select Name'} // Default to "Select Name" if name is null
                        onChange={(value) => {
                            const updatedData = [...dataSource];
                            updatedData[index].name = value; // Update name in the data source
                            setDataSource(updatedData);
                        }}
                    >
                        <Select.Option value="John Doe">John Doe</Select.Option>
                        <Select.Option value="Jane Smith">Jane Smith</Select.Option>
                        <Select.Option value="Alice Johnson">Alice Johnson</Select.Option>
                        <Select.Option value="User A">User A</Select.Option>
                        <Select.Option value="User B">User B</Select.Option>
                        <Select.Option value="User C">User C</Select.Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Alternate Signatory',
            dataIndex: 'userOptions',
            key: 'user',
            render: (userOptions) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select defaultValue={userOptions[0]} showSearch>
                        {userOptions.map((user, idx) => (
                            <Select.Option key={idx} value={user}>
                                {user}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Notification',
            dataIndex: 'NotificationPermissions',
            key: 'Notification Permissions',
            render: () => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select showSearch >
                            <Select.Option>
                                1
                            </Select.Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width:100,
            align:'center',
            render: () => (
                <Button type='primary' danger  icon={<DeleteOutlined />} />
            ),
        },
    ];

    const onChange = (key) => {
        console.log(key);
        setOpenItem(key);
    };

    const saveFormData=async()=>{
        if(openItem==2){
            let status = false;
            status = await createTeamRef.current.CreateTeam();
            if(status){
                setOpen(false);
                getAllTeams();
                setcount(count+1);
            }
        }
    }
    const refreshFirstView=()=>{
        getAllTeams();
        setcount(count+1);
    }
    const items = [
        {
            key: '1',
            label: 'Current Workflow',
            children: <CurrentTeams drawerClose={onClose} refreshfunc={refreshFirstView}/>,
        },
        {
            key: '2',
            label: 'Create Workflow',
            children: <CreateTeam setTeam={setTeam} initialTeam={defaultTeam} showTeamNameField={true} drawerClose={onClose} selectTeam={[]} hocusers={{}} ref={createTeamRef} />,
        },
    ];

    return (
        <>
            <Card
                bordered={false}
                title="Members"
                extra={<Button type='primary' icon={<AppstoreOutlined />} onClick={showDrawer}>Workflow Manager</Button>}
            >
                
                <CreateTeam key={count} setTeam={setTeam} initialTeam={team} showTeamNameField={showNameField} drawerClose={null} selectTeam={selectedTeams} hocusers={hocUsers} ref={currentTeamRef}/>
                <Checkbox checked={showNameField} onChange={handleCheckboxChange}>
                Retain team for later.
                </Checkbox>
                {/* {showInput && (
                    <Form style={{ marginTop: 16 }}>
                        <Form.Item>
                            <Input placeholder='Add your Team Name here' />
                        </Form.Item>
                    </Form>
                )} */}
            </Card>
            <Drawer
                title="Add | Edit Workflow"
                onClose={onClose}
                open={open}
                size='large'
                destroyOnClose={true}
                footer={[
                    <Flex justify='flex-end' align='center' gap='large'>
                        <Button onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="primary" onClick={()=>saveFormData()}>
                            Save
                        </Button>
                    </Flex>
                ]}
            >
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
            </Drawer>
        </>
    );
});
export default Members


// [
//     {
//         key:0,
//         teamName:"Team A",
//         members:[ // State for table data
//             {
//                 key: '0',
//                 actionOptions: ['Approve', 'View'],
//                 name: 'John Doe',
//                 userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
//             },
//             {
//                 key: '1',
//                 actionOptions: ['Approve', 'View'],
//                 name: 'Jane Smith',
//                 userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
//             },
//             {
//                 key: '2',
//                 actionOptions: ['Approve', 'View'],
//                 name: 'Alice Johnson',
//                 userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
//             },
//         ]
//     },
//     {
//         key:1,
//         teamName:"Team B",
//         members:[ // State for table data
//             {
//                 key: '0',
//                 actionOptions: ['Approve', 'View'],
//                 name: 'Sam Sam',
//                 userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
//             },
//             {
//                 key: '1',
//                 actionOptions: ['Approve', 'View'],
//                 name: 'Butcher',
//                 userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
//             },
//             {
//                 key: '2',
//                 actionOptions: ['Approve', 'View'],
//                 name: 'Taylor',
//                 userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
//             },
//         ]
//     },
    
// ]